<kehe-phoenix-top-navigation-panel [items]="items" appTitle="Supplier">
</kehe-phoenix-top-navigation-panel>
